// eslint-disable-next-line no-restricted-imports
import { Switch } from "@headlessui/react";
import clsx from "clsx";
import { FC, useContext } from "react";

import { t } from "i18n/i18n";
import { PillButton } from "mds/components/PillButton";
import { BypassReleaseWarningContext } from "providers/BypassReleaseWarningProvider";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectIsEditModeEnabled } from "store/selectors";
import { localStateActions } from "store/slices/local";

interface EditModeButtonProps {
  isDisabled?: boolean;
}

export const EditModeButton: FC<EditModeButtonProps> = ({ isDisabled }) => {
  const dispatch = useAppDispatch();
  const { resetWarning } = useContext(BypassReleaseWarningContext);
  const isEditModeEnabled = useAppSelector(selectIsEditModeEnabled);

  const toggleEditMode = () => {
    dispatch(localStateActions.setIsEditMode(!isEditModeEnabled));
    resetWarning();
  };

  return (
    <PillButton
      className={clsx(
        "flex items-center gap-2 transition",
        !isDisabled && "data-[active]:border-blue data-[active]:bg-blue-tint-90",
      )}
      data-active={isEditModeEnabled ? "true" : undefined}
      disabled={isDisabled}
      eventName="Edit Mode - Toggle"
      eventProps={{ isEnabled: !isEditModeEnabled }}
      kind="gray"
      size="m"
      onClick={toggleEditMode}
    >
      {t("main_header.edit_mode")}
      <Switch
        as="div"
        checked={isEditModeEnabled}
        className="group flex h-3.5 w-7 min-w-7 cursor-pointer items-center rounded-full bg-black-tint-70 transition data-[checked]:bg-blue data-[checked][data-disabled]:bg-black-tint-70"
        disabled={isDisabled}
      >
        <span className="size-3 translate-x-[0.0675rem] rounded-full bg-white shadow-md transition group-data-[checked]:translate-x-[0.9375rem]" />
      </Switch>
    </PillButton>
  );
};
